import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { getUserInitials } from 'helpers/getUserUIData'

import './styles.scss'

const baseClass = 'avatar-container'

const UserAvatar = ({ className, avatarClassName, initialClassName, avatar, userName, userLastName, userEmail }) => {
  const initials = getUserInitials(userName, userLastName, userEmail)

  return (
    <div
      className={classNames(baseClass, {
        [className]: className,
      })}
    >
      {avatar ? (
        <img
          src={avatar}
          alt={initials}
          className={classNames(`${baseClass}__avatar`, {
            [avatarClassName]: avatarClassName,
          })}
        />
      ) : (
        <div
          className={classNames(`${baseClass}__initials`, {
            [initialClassName]: initialClassName,
          })}
        >
          {initials}
        </div>
      )}
    </div>
  )
}

UserAvatar.propTypes = {
  className: PropTypes.string,
  avatarClassName: PropTypes.string,
  initialClassName: PropTypes.string,
  avatar: PropTypes.string,
  userName: PropTypes.string,
  userLastName: PropTypes.string,
  userEmail: PropTypes.string,
}

export default UserAvatar
